module.exports = __webpack_public_path__ + "img/19_5.e6cf59f2.png";